<ion-input type="text" class="full outline" [disabled]="IsDisabled" [value]="DisplayText"
    (click)="OnPresentPopover($event)" readonly [placeholder]="Placeholder" [title]="DisplayText" />

<ion-popover #popover [isOpen]="IsOpen" (didDismiss)="IsOpen = false" class="select-search rss-popover">
    <ng-template>
        <ion-header class="rss-header">
            <ion-toolbar>
                <ion-searchbar #search placeholder="pesquisar"></ion-searchbar>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]="false" class="ion-no-padding">
            <ng-container *ngIf="(Data | FilterByFields: (search?.value||'')) as filtered">
                <cdk-virtual-scroll-viewport class="ion-content-scroll-host rss-viewport" itemSize="40" minBufferPx="600"
                    maxBufferPx="1200" [style.height.px]="ViewportHeight(filtered.length)">

                    <ion-item *cdkVirtualFor="let item of filtered; trackBy: trackByFn" button detail="false"
                        lines="none" class="rss-option" [class.selected]="IsSelected(item)"
                        [class.disabled]="IsItemDisabled(item)" (click)="Select(item)">
                        <ion-label class="rss-label"
                            [title]="'[' + (item?.Code || '--') + '] ' + (item?.Description || '--')">[{{ item?.Code || '--' }}] {{ item?.Description || '--' }}</ion-label>
                        <ion-icon *ngIf="IsSelected(item)" slot="end" name="checkmark-outline" class="rss-check"
                            aria-hidden="true"></ion-icon>
                    </ion-item>

                    <div class="rss-empty" *ngIf="filtered.length == 0">sem resultados</div>
                </cdk-virtual-scroll-viewport>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-popover>
